import { paymentStatuses, type PaymentStatus } from "../types/PaymentStatus";

export const paymentStatusSelectOptions: {
  value: PaymentStatus;
  label: string;
}[] = paymentStatuses.map((value) => ({
  value,
  label: paymentStatusLabel(value),
}));

function paymentStatusLabel(status: PaymentStatus): string {
  switch (status) {
    case "open":
      return "Open";
    case "complete":
      return "Complete";
    case "expired":
      return "Expired";
    case "uncaptured":
      return "Uncaptured";
    case "requires_action":
      return "Requires action";
    case "cancelled":
      return "Cancelled";
    default:
      return status;
  }
}

export function formatPaymentStatus(status?: PaymentStatus | string | null): string {
  if (!status) return "Open";
  const found = paymentStatuses.find((s) => s === status);
  if (!found) return String(status);
  return paymentStatusLabel(found);
}

export function isPaymentStatus(v: unknown): v is PaymentStatus {
  return typeof v === "string" && (paymentStatuses as readonly string[]).includes(v);
}
